import { colors } from '../../theme/colors';

export const WALNUT_WALKTHROUGH_URL =
  'https://tour.themortgageoffice.com/player/?demoId=f4ff180e-e256-418c-9138-01a40b509f7c&showGuide=true&showGuidesToolbar=true&showHotspots=true&source=app';

export const PREVIEW_BACKGROUND_IMAGE = '/walnut-preview.png';

export const ModalSizing = {
  width: 768,
  previewAspectRatio: '768 / 434',
  previewPadding: '20px',
  borderRadius: 12,
  closeButtonSize: 56,
  closeButtonRadius: 36,
  dividerWidth: 320,
} as const;

export const PreviewButton = {
  // Desktop values
  borderRadius: 32,
  border: '8px solid #001e67',
  paddingX: '48px',
  paddingY: '26px',
  iconSize: 48,
  gap: 4, // theme spacing units (4 × 8 = 32px)
  // Mobile values (from Figma design)
  paddingXMobile: '24px',
  paddingYMobile: '20px',
  iconSizeMobile: 40,
} as const;

export const ModalTypography = {
  titleSizeDesktop: 32,
  titleSizeMobile: 24,
  descriptionSizeDesktop: 24,
  descriptionSizeMobile: 20,
  previewTextSizeDesktop: 40,
  previewTextSizeMobile: 32,
  checkboxLabelSize: 20,
  checkboxSize: 20,
} as const;

export const ModalColors = {
  textPrimary: colors.grey[600], 
  textSecondary: colors.text.secondary, 
  textMuted: colors.grey[500], 
  border: `2px solid ${colors.grey[400]}`,
  divider: colors.grey[400], 
  previewButtonBg: 'rgba(0, 0, 0, 0.65)',
  previewButtonBgHover: 'rgba(0, 0, 0, 0.75)',
  imageOverlay: colors.ui.shadow.dark,
  textWhite: 'rgba(255, 255, 255, 0.9)',
} as const;

export const ImagePositioning = {
  width: '131.19%',
  height: '133.44%',
  left: '-15.45%',
  opacity: 0.98,
} as const;

export const ModalZIndex = {
  closeButton: 1300,
} as const;
